import apiClient from '@/services/rest-api-tools/apiClient'

const baseEndpoint = '/sensor-type'

export const get = async (_params) => {
    const response = await apiClient({
        method: 'GET',
        url: `${baseEndpoint}`,
        params: _params,
    })
    return response?.data
}

export const getByRegion = async (serverRegion) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return response
}
